import { Injectable } from '@angular/core';

import { HttpClient } from '@angular/common/http';
import { HttpHeaders, HttpParams } from '@angular/common/http';

import { Callback, CognitoUtil } from './cognito.service';

import { environment } from '../../../environments/environment';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';

@Injectable()
export class BackendEndpointService {
  constructor(private cognitoUtil: CognitoUtil, private http: HttpClient) {}

  public getUserData() {
    return this.get(['users/cognito/userMapping']);
  }

  public buildHeaders(additionalOptions = null) {
    // copy the original options
    let ret = additionalOptions;
    if (!ret) {
      ret = {};
    }

    const param = this.cognitoUtil.getJwtToken() || '';

    const headers = {
      accesstoken: param
    };
    if (typeof ret.headers === 'undefined') {
      ret.headers = null;
    }
    ret.headers = new HttpHeaders({ ...ret.headers, ...headers });
    return ret;
  }

  public buildPath(path): string {
    if (Array.isArray(path)) {
      path = path.join('/');
    }

    if (path.charAt(0) !== '/') {
      path = '/' + path;
    }
    return environment.backendUrl + path;
  }

  public get(path, additionalHeaders = null): Promise<any> {
    path = this.buildPath(path);

    const httpOptions = this.buildHeaders(additionalHeaders);

    return this.http.get(path, httpOptions).toPromise();
  }

  public getO(path, additionalHeaders = null): Observable<any> {
    path = this.buildPath(path);

    const httpOptions = this.buildHeaders(additionalHeaders);

    return this.http.get<any>(path, httpOptions).pipe(catchError(err => this.handleError(err)));
  }

  public post(path, body, additionalHeaders = null): Promise<any> {
    path = this.buildPath(path);

    const httpOptions = this.buildHeaders(additionalHeaders);

    return this.http.post(path, body, httpOptions).toPromise();
  }

  public postO(path, body, additionalHeaders = null): Observable<any> {
    path = this.buildPath(path);

    const httpOptions = this.buildHeaders(additionalHeaders);

    return this.http.post<any>(path, body, httpOptions).pipe(catchError(err => this.handleError(err)));
  }

  public async postFile(path, formData, additionalHeaders = null): Promise<any> {
    // const headers = new HttpHeaders();
    // // this is the important step. You need to set content type as null
    // headers.set('Content-Type', null);
    // headers.set('Accept', 'multipart/form-data');
    // const httpOptions = this.buildHeaders(additionalHeaders);
    path = this.buildPath(path);

    additionalHeaders = {
      'Content-Type': null
      // 'Accept': 'multipart/form-data'
    };
    const httpOptions = this.buildHeaders(additionalHeaders);

    return this.http.post(path, formData, httpOptions).toPromise();
    // return this.returnData(this.backendEndpointService.post(path, body, httpOptions));
  }

  public put(path, body, additionalHeaders = null): Promise<any> {
    path = this.buildPath(path);

    const httpOptions = this.buildHeaders(additionalHeaders);

    return this.http.put(path, body, httpOptions).toPromise();
  }

  public putO(path, body, additionalHeaders = null): Observable<any> {
    path = this.buildPath(path);

    const httpOptions = this.buildHeaders(additionalHeaders);

    return this.http.put<any>(path, body, httpOptions).pipe(catchError(err => this.handleError(err)));
  }

  public delete(path, additionalHeaders = null): Promise<any> {
    path = this.buildPath(path);

    const httpOptions = this.buildHeaders(additionalHeaders);

    return this.http.delete(path, httpOptions).toPromise();
  }

  public deleteO(path, additionalHeaders = null): Observable<any> {
    path = this.buildPath(path);

    const httpOptions = this.buildHeaders(additionalHeaders);

    return this.http.delete<any>(path, httpOptions).pipe(catchError(err => this.handleError(err)));
  }

  private handleError(error) {
    return Observable.throw(error.json());
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/services/backend-endpoint.service.ts